var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"margin-left":"2px"},style:(_vm.config.style)},[_c('countTo',{attrs:{"startVal":_vm.start_num,"endVal":_vm.pre_number,"duration":_vm.duration,"decimals":this.fixed_num}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }